// @mui
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
// components
import { IconButtonAnimate } from "components/common/Animation";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuth } from "../../../../hooks";
import { useNavigate } from "react-router-dom";
import { paths } from "routes/paths";
import { getMedia } from "utils/apiHelper";
import { alpha, useTheme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const theme = useTheme();

  function handleNavigateProfile() {
    navigate(paths.profile);
  }

  return (
    <>
      <Stack
        flexDirection={"row"}
        alignItems="center"
        onClick={handleNavigateProfile}
        sx={{
          cursor: "pointer",
          borderRadius: 3,
          py: 0.75,
          px: 1,
          transition: theme.transitions.create(
            ["background-color", "transform"],
            {
              duration: theme.transitions.duration.shortest,
            }
          ),
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.04),
            transform: "scale(1.02)",
          },
        }}
      >
        <IconButtonAnimate
          sx={{
            p: 0,
          }}
          size={"large"}
        >
          <Avatar
            src={getMedia(user?.avatar!)}
            alt={user?.username}
            sx={{
              width: 42,
              height: 42,
              border: "2.5px solid transparent",
              background: `linear-gradient(${theme.palette.background.paper}, ${theme.palette.background.paper}) padding-box, linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main}) border-box`,
            }}
          />
        </IconButtonAnimate>

        <Stack
          justifyContent={"center"}
          alignItems={"flex-start"}
          sx={{ mr: 1.5 }}
        >
          <Typography
            variant={"body2"}
            fontWeight={"700"}
            gutterBottom={false}
            color="text.primary"
            sx={{ lineHeight: 1.4, letterSpacing: "-0.01em" }}
          >
            {`${user?.firstName} ${user?.lastName}`}
          </Typography>
          <Typography
            variant={"caption"}
            fontWeight={"400"}
            gutterBottom={false}
            color="text.disabled"
            sx={{ lineHeight: 1.2, fontSize: "0.7rem" }}
          >
            {`خوش آمدید`}
          </Typography>
        </Stack>
      </Stack>
    </>
  );
}
